import React, { useState, useEffect, useRef } from 'react';
import 'NOTICEBOARD/Components/Reports/DeprtmentNoticeCount/departmentnoticecount.css';
import NoticeboardAPICall from 'NoticeboardAPICall';
import config from 'config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spinner from 'NOTICEBOARD/CommonResources/SpinnerLoader/Spinner';
import { useReactToPrint } from 'react-to-print';
import ReactHtmlParser from 'react-html-parser';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Pagination from 'react-js-pagination';
import { toast } from 'react-toastify';

function DepartmentNoticeList() {

    const [academicYearList, setAcademicYearList] = useState({});
    const [academicYearSortedArr, setAcademicYearSortedArr] = useState([]);
    const [departmentList, setDepartmentList] = useState({});
    const [filterAcademicYear, setFilterAcademicYear] = useState([config?.instructorInfo?.AcaYearId]);
    const [selectedAcademicYear, setSelectedAcademicYear] = useState([config?.instructorInfo?.AcaYear]);
    const [filterDepartment, setFilterDepartment] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [fetchingReport, setFetchingReport] = useState(false);
    const [reportSequence, setReportSequence] = useState([]);
    const [reportDetails, setReportDetails] = useState({});
    const [reportCount, setReportCount] = useState('');
    const [instituteDepartment, setInstituteDepartment] = useState({});
    const [selectedInstDeptId, setSelectedInstDeptId] = useState([]);
    const [selectedInstDeptName, setSelectedInstDeptName] = useState([]);

    const [filterApplied, setFilterApplied] = useState(false);
    const [pagination, setPagination] = useState({
        pageIndex: 1,
        limit: 10,
        offset: 0
    });
    const [filterDisplay, setFilterDisplay] = useState(true);
    const [visibility, setVisibility] = useState([
        { name: 'Title', visibility: true },
        { name: 'Category', visibility: true },
        { name: 'Notice Id', visibility: true },
        { name: 'Department', visibility: true },
        { name: 'Institute Department', visibility: true },
        { name: 'Year', visibility: true },
        { name: 'Posted By', visibility: true },
        { name: 'Notice Date & Time', visibility: true },
        { name: 'Viewed Count', visibility: true },
        { name: 'Assignee Count', visibility: true }
    ]);

    const componentRef = useRef();

    useEffect(() => {
        apiCallToGetAcademicYearList();
        apiCallToGetDepartmentList();
        apiCallToGetInstituteDepartment();
        apiCallToGetReportList();
    }, []);



    useEffect(() => {
        apiCallToGetReportList();
    }, [pagination.pageIndex, pagination.limit, pagination.offset]);

    // METHOD FOR SET SHOW RESULT
    const setShowResult = (e) => {
        setPagination({
            pageIndex: 1,
            limit: e.target.value,
            offset: 0
        });
    }

    const apiCallToGetInstituteDepartment = async () => {
        let formData = {
            institute_id: config.institute_id,
        };

       
        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'getDepartmentsListWithoutPagination',
            formData,
            "/api/instructor/instituteDepartments.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetInstituteDepartment()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data
                setInstituteDepartment(apiResult)
               
            } else {
                toast.error("Something went wrong while getting institute department. Please contact.")
            }
        }
    }

    // API CALL METHOD TO GET ACADEMIC YEAR LIST
    const apiCallToGetAcademicYearList = async () => {
        let formData = {
            iid: config.institute_id,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetAcademicYearListObject",
            formData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetAcademicYearList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setAcademicYearSortedArr(jsonResponse.APIResult.sortedIdArray);
                if(Object.keys(apiResult).length > 0 ) 
                {
                    Object.keys(apiResult)?.map(yearId => {
                        apiResult[yearId]['yearId'] = yearId;
                    });
                }
                setAcademicYearList(apiResult);
            }
        }
    }

    // API CALL METHOD TO GET DEPARTMENT LIST
    const apiCallToGetDepartmentList = async () => {
        let formData = {
            iid: config.institute_id,
            sidArray: [],
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetInstituteStreamsObject",
            formData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetDepartmentList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = await jsonResponse.APIResult.data;
                if(Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(streamId => {
                        apiResult[streamId]['departmentId'] = streamId;
                    });
                }

                setDepartmentList(apiResult);
            }
        }
    }

    const selectInstDept = (dept) =>{
        setFilterDepartment([]);
        setSelectedDepartment([]);
        let selectedInstituteDepartmentId= selectedInstDeptId
        let selectedInstituteDepartmentName= selectedInstDeptName

        if(selectedInstituteDepartmentId.includes(dept.Id)) {
            selectedInstituteDepartmentId = selectedInstituteDepartmentId.filter(id => id != dept.Id);
            selectedInstituteDepartmentName = selectedInstituteDepartmentName.filter(name => name != (dept.name ));
        }else {
            selectedInstituteDepartmentId.push(dept.Id);
            selectedInstituteDepartmentName.push(dept.name);
        }

        setSelectedInstDeptId([ ...selectedInstituteDepartmentId ]);
        setSelectedInstDeptName([ ...selectedInstituteDepartmentName ]);

    }

    // METHOD TO SELECT ACADEMIC YEAR
    const selectFilterYear = (year) => {
        let filterYear = filterAcademicYear;
        let selectedYear = selectedAcademicYear;

        if(filterYear.includes(year.yearId)) {
            filterYear = filterYear.filter(id => id != year.yearId);
            selectedYear = selectedYear.filter(text => text != year.year_text);
        }else {
            filterYear.push(year.yearId);
            selectedYear.push(year.year_text);
        }

        setFilterAcademicYear([ ...filterYear ]);
        setSelectedAcademicYear([ ...selectedYear ]);
    }

    // METHOD TO SELECT DEPARTMENT
    const selectDepartment = (department) => {
        setSelectedInstDeptId([]);
        setSelectedInstDeptName([]);
        let filterDept = filterDepartment;
        let selectedDept = selectedDepartment;

        if(filterDept.includes(department.departmentId)) {
            filterDept = filterDept.filter(id => id != department.departmentId);
            selectedDept = selectedDept.filter(dept => dept != department.stream_name);
        }else {
            filterDept.push(department.departmentId);
            selectedDept.push(department.stream_name);
        }

        setFilterDepartment([ ...filterDept ]);
        setSelectedDepartment([ ...selectedDept ]);
    }

    // METHOD TO APPLY FILTER
    const applyFilter = () => {
        setFilterApplied(true);
        apiCallToGetReportList();
    }

    // API CALL METHOD TO GET NOTICE COUNT DETAILS
    const apiCallToGetReportList = async () => {
        setFetchingReport(true);

        let requestData = {
            "iid": config.institute_id,
            "page_index": pagination.pageIndex,
            "limit": pagination.limit,
            "academicYearArray": filterAcademicYear ,
            "sidArray": filterDepartment,
            "instDeptArray": selectedInstDeptId ,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getDepartmentWiseNoticeList",
            requestData,
            '/api/notice/notice.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetReportList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setReportSequence(jsonResponse.APIResult.sequenceIdArray);
                setReportDetails(apiResult);
                setReportCount(jsonResponse.APIResult.totalCount);
                setFetchingReport(false);
            }
        }
    }

    // METHOD TO CLEAR FILTER
    const clearFilter = () => {
        setFilterAcademicYear([]);
        setSelectedAcademicYear([]);
        setFilterDepartment([]);
        setSelectedInstDeptId([])
        setSelectedInstDeptName([])
        setSelectedDepartment([]);
        setReportDetails({});
        setFilterApplied(false);
    }

    // METHOD TO UPDATE COLUMN DISPLAY
    const updateColumnDisplay = (index) => {
        let visibilityDetails = visibility;

        visibilityDetails[index].visibility = !visibilityDetails[index].visibility;

        setVisibility([ ...visibilityDetails ]);
    }

	// METHOD TO REPORT PAGINATION COUNT
	const updateReportPagination = (pageNumber) => {
		setPagination(prev => ({
			...prev, 
            offset: (pageNumber - 1) * pagination.limit,
            pageIndex: pageNumber
		}));
	}

    // METHOD TO PRINT REPORT
    const printReport = useReactToPrint({
        content: () => componentRef.current,
    });

    // METHOD TO EXPORT REPORT
    const exportReport = () => {
        document.getElementById('exportReport').click();
    }

    // METHOD TO RETURN REPORT TABLE COMPONENT
    const ReportTable = React.forwardRef((props, ref) => {
        return(
            <div className="mainDataContainer">
                {
                    fetchingReport ?
                        <Spinner />
                        :
                        <>
                            {
                                Object.keys(reportDetails).length > 0
                                ?
                                <div className="report-container" ref={componentRef}>
                                    <div className="college-info">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.institute_full_name)}</p>
                                    </div>
                                    <div className="report-name-print col-md-12">
                                        Department wise Notice List Report
                                    </div>
                                    <div className="col-md-12 reportDetails-container" style={{ padding: 0 }}>
                                        <table className="table table-bordered table-fixed" id="countTable" style={{ backgroundColor: '#FFF' }}>
                                            <thead>
                                                <tr style={{ display: 'none' }}>
                                                    <th style={{ padding: 5 }} colSpan={visibility.length + 1}>
                                                        {ReactHtmlParser(config.institute_full_name)}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>Sr. No.</th>
                                                    {
                                                        visibility.map(header => {
                                                            if (header.visibility) {
                                                                return (
                                                                    <th style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{header.name}</th>
                                                                );
                                                            }
                                                        })
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    Object.keys(reportDetails).length > 0 ?
                                                        reportSequence.map((noticeId, noticeIndex) => {
                                                            let notice = reportDetails[noticeId];
                                                            return (
                                                                <tr key={notice.noticeId}>
                                                                    <td style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{pagination.offset + noticeIndex + 1}.</td>
                                                                    {
                                                                        visibility[0].visibility &&
                                                                        <td style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{notice.title}</td>
                                                                    }
                                                                    {
                                                                        visibility[1].visibility &&
                                                                        <td style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{notice.categoryName}</td>
                                                                    }
                                                                    {
                                                                        visibility[2].visibility &&
                                                                        <td style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{notice.categorySeries.length > 0 && `${notice.categorySeries}-${notice.categoryNumber}`}</td>
                                                                    }
                                                                    {
                                                                        visibility[3].visibility &&
                                                                        <td style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{notice.department}</td>
                                                                    }
                                                                    {
                                                                        visibility[4].visibility &&
                                                                        <td style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{notice.instituteName}</td>
                                                                    }
                                                                    {
                                                                        visibility[5].visibility &&
                                                                        <td style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{notice.academicYear}</td>
                                                                    }
                                                                    {
                                                                        visibility[6].visibility &&
                                                                        <td style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{notice.addedBy}</td>
                                                                    }
                                                                    {
                                                                        visibility[7].visibility &&
                                                                        <td style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{notice.formattedNoticeDate}</td>
                                                                    }
                                                                    {
                                                                        visibility[8].visibility &&
                                                                        <td style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{notice.totalViews}</td>
                                                                    }
                                                                    {
                                                                        visibility[9].visibility &&
                                                                        <td style={{ padding: 5, whiteSpace: 'normal', wordBreak: 'break-word' }}>{notice.assigneeCount}</td>
                                                                    }
                                                                </tr>
                                                            );
                                                        })
                                                        :
                                                        <tr>
                                                            <td style={{ padding: 5 }} colSpan={9}>No notice list found for selected academic year(s).</td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                  :
                                <p style={{ marginTop: 10, fontSize: 14 }}>Please select academic year from filter to get details.</p>
                            }
                        </>
                }
            </div>
        );
    });

    return (
        <>
            <div className="col-md-12">
                <div className="filter-options">
                    <div className="filter-values col-md-6" style={{ paddingLeft: 0 }}>
                        <button className="btn outline-button" onClick={() => setFilterDisplay(!filterDisplay)}>
                            <FontAwesomeIcon icon={['fas', 'filter']} style={{ marginRight: 5 }} />
                            Filter
                        </button>
                    </div>
                    {
                        (Object.keys(reportDetails).length > 0 && !fetchingReport) &&
                            <div className="export-values col-md-6" style={{ paddingRight: 0 }}>
                                <div style={{ display: 'none' }}>
                                    <ReactHTMLTableToExcel
                                        id="exportReport"
                                        className="download-table-xls-button btn btn-success mb-3"
                                        table="countTable"
                                        filename="Department wise Notice List Report"
                                        sheet="tablexls"
                                        buttonText="Export"
                                    />
                                </div>
                                <button className="btn outline-button filter-button" onClick={() => exportReport()}>
                                    <FontAwesomeIcon icon={['fas', 'file-export']} style={{ marginRight: 5 }} />
                                    Export
                                </button>
                                <button className="btn outline-button filter-button" onClick={() => printReport()}>
                                    <FontAwesomeIcon icon={['fas', 'print']} style={{ marginRight: 5 }} />
                                    Print
                                </button>
                                <div className="setting-button">
                                    <div className="dropdown dropleft">
                                        <FontAwesomeIcon className="reportFilter-icon" title="Click to select required columns in the report" data-toggle="dropdown" icon={['fas', 'cog']} style={{ cursor: 'pointer' }} />
                                        <div id="settingDropdown" className="dropdown-menu filterDropdownMenu">
                                            {
                                                visibility.map((columnInfo, index) => {
                                                    return (
                                                        <p className="dropdown-item" style={{ display: 'flex', alignItems: 'center', padding: '5px 10px' }} key={columnInfo.name} onClick={() => updateColumnDisplay(index)}>
                                                            <input type="checkbox" style={{ marginRight: 5 }} checked={columnInfo.visibility} />
                                                            <span style={{ fontSize: 14 }}>{columnInfo.name}</span>
                                                        </p>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                </div>
                {
                    filterDisplay &&
                        <div style={{ marginTop: 10 }} className="filter-container">
                            <div className="row col-md-12">
                                <div className="academicYear col-md-3">
                                    <label style={{ marginBottom: 0, fontSize: 14, fontWeight: 'bold' }}>Academic Year <span style={{ color: 'red' }}>*</span></label>
                                    <div className="dropdown">
                                        <input
                                            type="text"
                                            className="form-control filterReportInput"
                                            placeholder='Click to select academic year'
                                            data-toggle="dropdown"
                                            readOnly
                                        />
                                        <div id="academicYearDropdown" className="dropdown-menu filterDropdownMenu" style={{ width: '100%' }}>
                                            {
                                                Object.keys(academicYearList).length > 0 ?
                                                    academicYearSortedArr.map(yearId => {
                                                        let year  = academicYearList[yearId];
                                                        return (
                                                            <p className="dropdown-item" style={{ display: 'flex', alignItems: 'center', padding: '5px 10px' }} key={year.yearId} onClick={() => selectFilterYear(year)}>
                                                                <input
                                                                    type='checkbox'
                                                                    checked={filterAcademicYear.includes(year.yearId)}
                                                                    style={{ marginRight: 5 }}
                                                                />
                                                                <span style={{ fontSize: 14 }}>{year.year_text}</span>
                                                            </p>
                                                        );
                                                    })
                                                :
                                                    <p style={{ color: '#818181', fontSize: 12 }}>No academic year details found.</p>
                                            }
                                        </div>
                                        
                                        <p style={{ fontSize: 14 }}>{selectedAcademicYear.join(', ')}</p>
                                    </div>
                                </div>
                                <div className="departmentSelection col-md-3">
                                    <label style={{ marginBottom: 0, fontSize: 14, fontWeight: 'bold' }}>Department</label>
                                    <div className="dropdown">
                                        <input
                                            type="text"
                                            className="form-control filterReportInput"
                                            placeholder='Click to select department'
                                            data-toggle="dropdown"
                                            disabled = {selectedInstDeptName.length > 0}
                                            readOnly
                                        />
                                        <div id="departmentDropdown" className="dropdown-menu filterDropdownMenu" style={{ width: '100%' }}>
                                            {
                                                Object.keys(departmentList).length > 0 ?
                                                    Object.values(departmentList).map(department => {
                                                        return (
                                                            <p className="dropdown-item" style={{ display: 'flex', alignItems: 'center', padding: '5px 10px' }} key={department.departmentId} onClick={() => selectDepartment(department)}>
                                                                <input
                                                                    type='checkbox'
                                                                    checked={filterDepartment.includes(department.departmentId)}
                                                                    style={{ marginRight: 5 }}
                                                                />
                                                                <span style={{ fontSize: 14 }}>{department.stream_name}</span>
                                                            </p>
                                                        );
                                                    })
                                                :
                                                    <p style={{ color: '#818181', fontSize: 12 }}>No department details found.</p>
                                            }
                                        </div>
                                        <p style={{ fontSize: 14 }}>{selectedDepartment.join(', ')}</p>
                                    </div>
                                </div>
                                <div className="departmentSelection col-md-3">
                                    <label style={{ marginBottom: 0, fontSize: 14, fontWeight: 'bold' }}>Institute Department</label>
                                    <div className="dropdown">
                                        <input
                                            type="text"
                                            className="form-control filterReportInput"
                                            placeholder='Click to select department'
                                            data-toggle="dropdown"
                                            disabled = {filterDepartment.length > 0 }
                                            readOnly
                                        />
                                        <div id="instDepartmentDropdown" className="dropdown-menu filterDropdownMenu" style={{ width: '100%' }}>
                                            {
                                                Object.keys(instituteDepartment).length > 0 ?
                                                    Object.values(instituteDepartment).map(department => {
                                                        return (
                                                            <p className="dropdown-item" style={{ display: 'flex', alignItems: 'center', padding: '5px 10px' }} key={department.Id} onClick={() => {filterDepartment.length == 0 && selectInstDept(department)}}>
                                                                <input
                                                                    type='checkbox'
                                                                    checked={selectedInstDeptId.includes(department.Id)}
                                                                    style={{ marginRight: 10 }}
                                                                />
                                                                <span style={{ fontSize: 14 }}>{department.name}</span>
                                                            </p>
                                                        );
                                                    })
                                                :
                                                    <p style={{ color: '#818181', fontSize: 12 }}>No Institute Department found.</p>
                                            }
                                        </div>
                                        <p style={{ fontSize: 14 }}>{selectedInstDeptName.join(', ')}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="filter-buttons">
                                <button className="btn primary-button filter-button" onClick={() => applyFilter()} disabled={filterAcademicYear.length == 0}>Apply</button>
                                <button className="btn outline-button filter-button" onClick={() => clearFilter()}>Clear</button>
                            </div>
                        </div>
                }
                <ReportTable />
                {
                    (Object.keys(reportDetails).length > 0 && !fetchingReport) &&
                    <div className='d-flex justify-content-between'>
                        <div className='d-flex align-items-center' style={{ paddingRight: 0 }}>
                            <div className='smallFont secondaryColor mx-2'>Show Entries</div>
                            <div className=''>
                                <select
                                    className="form-select postNoticeInput rounded"
                                    aria-label="Default select example"
                                    value={pagination.limit}
                                    onChange={(e) => setShowResult(e)}
                                    style={{ border: '1px solid gray', outline: 'none' }}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="40">40</option>
                                    <option value="100">100</option>
                                    <option value="250">250</option>
                                </select>
                            </div>
                            &nbsp;&nbsp;

                        </div>
                        <div className="paginationContainer1">
                            <Pagination
                                activePage={pagination.pageIndex}
                                itemsCountPerPage={pagination.limit}
                                totalItemsCount={reportCount}
                                pageRangeDisplayed={3}
                                onChange={(num) => updateReportPagination(num)}
                            />
                        </div>

                        <div className='mt-2' style={{ fontSize: 'smaller' }} >
                            Total records: {reportCount}
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default DepartmentNoticeList;